export enum RugbyLeagueDropGoalAttribute {
  Golden = 2993,
  One = 2994,
  Two = 2995,
}
